const TOKEN_PREFIX = 'mcpat_';
const SECRET_LENGTH = 40;
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const UNBIASED_LIMIT = 256 - (256 % ALPHABET.length);

export const MAX_LIFETIME_DAYS_OPTIONS = [30, 90, 180, 365];
export const DEFAULT_MAX_LIFETIME_DAYS = 365;
export const DEFAULT_LIFETIME_DAYS = 30;

const randomBytes = () => crypto.getRandomValues(new Uint8Array(SECRET_LENGTH));

export const generateSecret = () => {
  let secret = '';
  while (secret.length < SECRET_LENGTH) {
    const bytes = randomBytes();
    for (let i = 0; i < bytes.length && secret.length < SECRET_LENGTH; i++) {
      if (bytes[i] < UNBIASED_LIMIT) {
        secret += ALPHABET[bytes[i] % ALPHABET.length];
      }
    }
  }
  return `${TOKEN_PREFIX}${secret}`;
};

export const sha256Hex = (input) => crypto.subtle.digest('SHA-256', new TextEncoder().encode(input))
  .then((digest) => Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join(''));
